export default __webpack_public_path__ + "static/blog-blocks-wallpaper-1591056-2-d22aa8ce42d216e432f4f6954546e2dc.jpg";